module.exports = __webpack_public_path__ + "static/img/xcx1.b34a200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xcx1.jpg
// module id = BAsD
// module chunks = 5